/* Info Component in MoodboardsPage */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../styles/Callsheets.module.css";

const Info = () => {
  return (
    <div>
        <Row className='mb-3'>
            <Col className={`px-3 py-2 ${styles.SubTitle6 }`} md={{span: 10, offset: 1 }}>
            <h5 className={`text-center ${styles.Red }`} >MOODBOARDS INFO</h5> 
            <hr className={`mt-2 mb-0`}/>
              <p className='pt-2'>
              <span className={`${styles.Red}`}>*</span> <span className={`${styles.Red}`}>Create</span> Moodboards for Visual Themes and Production Elements.</p>
              <p className='pt-2'>
              <span className={`${styles.Red}`}>*</span> Create <span className={`${styles.Red}`}>Moodboards</span> for Scenes, Locations and Characters.</p>
              <p className='pt-2'>
              <span className={`${styles.Red}`}>*</span> The Scenes, Location and Character Moodboards can be <span className={`${styles.Red}`}>created</span> on their pages or 
              on the main Moodboards page. </p>
              <p className='pt-2'><span className={`${styles.Red}`}>*</span> Each element may have <span className={`${styles.Red}`}>as many</span> Moodboards as needed. </p>
              <p className='pt-2'><span className={`${styles.Red}`}>*</span> Each Moodboard may be solely for 
              a Scene, Location and Character or for two or three elements.</p>
              <p className='pt-2'>
              <span className={`${styles.Red}`}>*</span> Moodboards for Visual Themes and Production Elements are created by using the <span className={`${styles.Red}`}>Title</span> only. 
            </p>
            <hr className={`mt-2 mb-0`}/>
            </Col>
        </Row>
    </div>
  )
}

export default Info